
import Footer2 from '../Components/Footer/Footer2';  
import Footer from '../Components/Footer/Footer';
import NotFoundComp from '../Components/404/NotFoundComp';
import NavBar from '../Components/NavBar';
import TabBottom from '../Components/TabBottom';


function NotFound() {
  
  return (
    <div className='row   mx-0 '>
    <div className='col-12  px-0'>
      <NavBar/>
      {/* <Men/> */}
      <div className='row mx-0 '>
        <div className='col-12 px-0 h-100'>

   <NotFoundComp/>

        </div>

       <Footer/>
      <Footer2/>
     
  
   </div>
   <TabBottom/>
      </div>
     </div>
  );
}

export default NotFound;
